module.exports = __webpack_public_path__ + "c6d908ef358d9b74d913e492b5def7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bullet-green.png
// module id = 585
// module chunks = 0